module.exports = __webpack_public_path__ + "static/media/dråpe.1e9ed8f0.m4a";